import axios from 'axios';
import {
    interceptorsRequest,
    interceptorsRequestError,
    interceptorsResponse,
    interceptorsResponseError,
} from './interceptors';

let API = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    responseType: 'json',
});
API.defaults.headers.post['content-type'] = 'application/json';
API.defaults.headers.get['Accept'] = 'application/json';

API.interceptors.request.use(
    (request) => {
        const interceptorsReq = interceptorsRequest(request);
        return interceptorsReq;
    },
    (error) => {
        const promiseError = interceptorsRequestError(error);
        return promiseError;
    }
);

API.interceptors.response.use(
    (response) => {
        // Dispatch that we finished loading.
        const interceptorsRes = interceptorsResponse(response);
        return interceptorsRes;
    },
    (error) => {
        const responseError = interceptorsResponseError(error);
        return responseError;
    }
);

export default API;
